import React, { Component } from 'react';
import moment from 'moment';
import { Input, Form, Row, Col, Modal, message, Button, DatePicker, Select } from 'antd';
import { Message } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import { localStorageClient } from '../../../../../utils/localStorageClient';

const FormItem = Form.Item;
const TextArea = Input.TextArea;
const Option = Select.Option;
const DATE_FORMAT = 'DD-MMM-YYYY';

const formItemLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

class AddOrEditGroupDirShModalDialog extends Component {

    componentDidUpdate() {
        const {
            submitAddGroupDirShStatus,
            submitUpdateGroupDirShStatus,
        } = this.props;

        if (submitAddGroupDirShStatus === ACTION_STATUS.SUCCESS) {
            message.success('Add Group DirSh succeeded');
            this.props.initSubmitAddGroupDirShActionStatus();
            this.props.resetAddOrEditGroupDirShModal();
            this.props.queryGroupDirSh();
        }
        if (submitAddGroupDirShStatus === ACTION_STATUS.ERROR) {
            this.props.initSubmitAddGroupDirShActionStatus();
        }

        if (submitUpdateGroupDirShStatus === ACTION_STATUS.SUCCESS) {
            message.success('Edit Group DirSh succeeded');
            this.props.initSubmitUpdateGroupDirShActionStatus();
            this.props.resetAddOrEditGroupDirShModal();
            this.props.queryGroupDirSh();
        }
        if (submitUpdateGroupDirShStatus === ACTION_STATUS.ERROR) {
            this.props.initSubmitUpdateGroupDirShActionStatus();
        }
    }

    onInputChange = ({ name, value }) => {
        this.props.addOrEditGroupDirShChangeInput({ name, value });
    }

    getModalTitle() {
        return this.props.groupDirShModal.mode === 'ADD' ? 'Add Group DirSh' : 'Edit Group DirSh';
    }

    getSubmitLoading = () => {
        const { mode } = this.props.groupDirShModal;
        if (mode === 'ADD') {
            return this.props.submitAddGroupDirShStatus === ACTION_STATUS.LOGINING;
        }
        return this.props.submitUpdateGroupDirShStatus === ACTION_STATUS.LOGINING;
    }

    submitAddOrEditGroupDirSh = () => {
        const { mode, fields } = this.props.groupDirShModal;

        this.props.form.validateFields((err, values) => {
            if (err) {
                return;
            }

            const now = moment();
            const payload = {
                id: fields.id,
                entityNameEng: values.entityNameEng,
                entityNameOther: values.entityNameOther,
                incorpNo: values.incorpNo,
                entityCode: values.entityCode,
                incorpPlace: values.incorpPlace,
                position: values.position,
                holdingPct: values.holdingPct,
                legalNameEng: values.legalNameEng,
                legalNameOther: values.legalNameOther,
                effectiveDate: values.effectiveDate ? values.effectiveDate.format('YYYY-MM-DD') : undefined,
                endDate: values.endDate ? values.endDate.format('YYYY-MM-DD') : fields.endDate,
                remarks: values.remarks,
                lastUpdatedBy: localStorageClient.getUserName(),
                lastUpdateTime: now.format('YYYY-MM-DD HH:mm:ss'),
            };

            if (mode === 'ADD') {
                this.props.submitAddGroupDirSh(payload);
            } else {
                this.props.submitUpdateGroupDirSh(payload);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const groupDirShModal = this.props.groupDirShModal || { isOpened: false, respErrMsg: '', fields: {} };
        const { isOpened, respErrMsg } = groupDirShModal;
        const {
            entityNameEng,
            entityNameOther,
            incorpNo,
            entityCode,
            incorpPlace,
            position,
            holdingPct,
            legalNameEng,
            legalNameOther,
            effectiveDate,
            endDate,
            remarks,
        } = groupDirShModal.fields;
        const countryOptions = (this.props.countryCodeDOArray || [])
            .slice()
            .sort((a, b) => (a.countryDesc || '').localeCompare(b.countryDesc || ''))
            .map(country => (
                <Option key={country.countryDesc} value={country.countryDesc}>
                    {country.countryDesc}
                </Option>
            ));

        const isSubmitLoading = this.getSubmitLoading();
        const effectiveDateValue = effectiveDate ? moment(effectiveDate) : undefined;
        const endDateValue = endDate ? moment(endDate) : undefined;

        return (
            <div>
                <Modal
                    title={this.getModalTitle()}
                    centered
                    width={900}
                    visible={isOpened}
                    destroyOnClose={true}
                    maskClosable={false}
                    onCancel={() => this.props.resetAddOrEditGroupDirShModal()}
                    footer={[
                        <Button key='Cancel' onClick={() => this.props.resetAddOrEditGroupDirShModal()}>
                            Cancel
                        </Button>,
                        <Button key='Submit' type='primary' loading={isSubmitLoading} onClick={this.submitAddOrEditGroupDirSh}>
                            Submit
                        </Button>,
                    ]}
                >
                    <Form layout='horizontal'>
                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label='Entity Name Eng'>
                                    {getFieldDecorator('entityNameEng', {
                                        initialValue: entityNameEng,
                                        rules: [{ required: true, message: 'Please input Entity Name in English' }],
                                    })(
                                        <Input style={{ width: 220, marginLeft: 10 }} onChange={e => this.onInputChange({ name: 'entityNameEng', value: e.target.value })} />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label='Entity Name Other'>
                                    {getFieldDecorator('entityNameOther', {
                                        initialValue: entityNameOther,
                                    })(
                                        <Input style={{ width: 220, marginLeft: 10 }} onChange={e => this.onInputChange({ name: 'entityNameOther', value: e.target.value })} />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label='Incorp No'>
                                    {getFieldDecorator('incorpNo', {
                                        initialValue: incorpNo,
                                        rules: [{ required: true, message: 'Please input Incorporation No' }],
                                    })(
                                        <Input style={{ width: 220, marginLeft: 10 }} onChange={e => this.onInputChange({ name: 'incorpNo', value: e.target.value })} />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label='Entity Code'>
                                    {getFieldDecorator('entityCode', {
                                        initialValue: entityCode,
                                        rules: [{ required: true, message: 'Please input entityCode' }],
                                    })(
                                        <Input style={{ width: 220, marginLeft: 10 }} onChange={e => this.onInputChange({ name: 'entityCode', value: e.target.value })} />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label='Incorp Place'>
                                    {getFieldDecorator('incorpPlace', {
                                        initialValue: incorpPlace,
                                        rules: [{ required: true, message: 'Please input Place of Incorporation' }],
                                    })(
                                        <Select
                                            allowClear
                                            showSearch
                                            optionFilterProp='children'
                                            style={{ width: 220, marginLeft: 10 }}
                                            onChange={value => this.onInputChange({ name: 'incorpPlace', value })}
                                        >
                                            {countryOptions}
                                        </Select>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label='Position'>
                                    {getFieldDecorator('position', {
                                        initialValue: position,
                                        rules: [{ required: true, message: 'Please input Position' }],
                                    })(
                                        <Input style={{ width: 220, marginLeft: 10 }} onChange={e => this.onInputChange({ name: 'position', value: e.target.value })} />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label='Shareholding %'>
                                    {getFieldDecorator('holdingPct', {
                                        initialValue: holdingPct,
                                    })(
                                        <Input style={{ width: 220, marginLeft: 10 }} onChange={e => this.onInputChange({ name: 'holdingPct', value: e.target.value })} />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label='Legal Name Eng'>
                                    {getFieldDecorator('legalNameEng', {
                                        initialValue: legalNameEng,
                                    })(
                                        <Input style={{ width: 220, marginLeft: 10 }} onChange={e => this.onInputChange({ name: 'legalNameEng', value: e.target.value })} />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label='Legal Name Other'>
                                    {getFieldDecorator('legalNameOther', {
                                        initialValue: legalNameOther,
                                    })(
                                        <Input style={{ width: 220, marginLeft: 10 }} onChange={e => this.onInputChange({ name: 'legalNameOther', value: e.target.value })} />
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label='Effective Date'>
                                    {getFieldDecorator('effectiveDate', {
                                        initialValue: effectiveDateValue,
                                        rules: [{ required: true, message: 'Please select Effective Date' }],
                                    })(
                                        <DatePicker
                                            format={DATE_FORMAT}
                                            style={{ width: 220, marginLeft: 10 }}
                                            onChange={(date, dateString) => this.onInputChange({ name: 'effectiveDate', value: dateString })}
                                        />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={12}>
                                <FormItem {...formItemLayout} label='End Date'>
                                    {getFieldDecorator('endDate', {
                                        initialValue: endDateValue,
                                    })(
                                        <DatePicker
                                            format={DATE_FORMAT}
                                            style={{ width: 220, marginLeft: 10 }}
                                            onChange={(date, dateString) => this.onInputChange({ name: 'endDate', value: dateString })}
                                        />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col span={24}>
                                <FormItem labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} label='Remarks'>
                                    {getFieldDecorator('remarks', {
                                        initialValue: remarks,
                                    })(
                                        <TextArea rows={4} style={{ width: 600, marginLeft: 10 }} onChange={e => this.onInputChange({ name: 'remarks', value: e.target.value })} />
                                    )}
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>

                    {!!respErrMsg &&
                        <Message negative>
                            <Message.Header>Response Error Message</Message.Header>
                            <p>{respErrMsg}</p>
                        </Message>
                    }
                </Modal>
            </div>
        );
    }
}

const AddOrEditGroupDirShModalDialogForm = Form.create({ name: 'AddOrEditGroupDirShModalDialog' })(AddOrEditGroupDirShModalDialog);
export default AddOrEditGroupDirShModalDialogForm;
